const SENSITIVE_KEYS = new Set([
  'token',
  'authorization',
  'password',
  'passwd',
  'secret',
  'api_key',
  'apikey',
  'cookie',
]);

const isJwtLike = (value) => {
  if (typeof value !== 'string') {
    return false;
  }
  const parts = value.split('.');
  return parts.length === 3 && value.startsWith('eyJ');
};

const maskValue = (value) => {
  if (typeof value !== 'string') {
    return '[redacted]';
  }
  if (value.length <= 8) {
    return '[redacted]';
  }
  return `${value.slice(0, 4)}...${value.slice(-4)}`;
};

export const redactSensitive = (input, seen = new WeakSet()) => {
  if (input === null || input === undefined) {
    return input;
  }

  if (typeof input === 'string') {
    return isJwtLike(input) ? maskValue(input) : input;
  }

  if (typeof input !== 'object') {
    return input;
  }

  if (seen.has(input)) {
    return input;
  }
  seen.add(input);

  if (Array.isArray(input)) {
    return input.map((item) => redactSensitive(item, seen));
  }

  const output = {};
  Object.entries(input).forEach(([key, value]) => {
    const lowerKey = key.toLowerCase();
    if (SENSITIVE_KEYS.has(lowerKey)) {
      output[key] = maskValue(String(value || ''));
    } else {
      output[key] = redactSensitive(value, seen);
    }
  });
  return output;
};
